import { Component, OnInit, OnChanges, Input, Output, EventEmitter, ElementRef, ViewChild, NgZone, AfterViewInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators, FormGroup, FormControl } from '@angular/forms';
import { HealthCareProviderInfo } from 'src/app/models/healthCareProviderInfo';
import { PersonalInfo } from 'src/app/models/personalInfo';
import { HealthCareProviderInfoService } from 'src/app/services/health-care-provider-info.service';
import { Claim } from 'src/app/models/claim';
import { ValidationService } from 'src/app/services/validation.service';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import moment from 'moment';
import 'moment/locale/fr';
import { TimeoutService } from 'src/app/services/timeout.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DynamicScriptsService, Maps } from 'src/app/services/dynamic-scripts.service';
import { CommonModule } from '@angular/common';
import { FieldErrorDisplayComponent } from '../../field-error-display/field-error-display.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { ReactiveFormsModule } from '@angular/forms';
import { datePickerValidationCheckImpl, MY_FORMATS, loadDateToMoment } from 'src/app/services/sharedHelper';

@Component({
  selector: 'app-health-care',
  templateUrl: './health-care.component.html',
  styleUrls: ['./health-care.component.css'],
  providers: [
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
  imports: [  
      CommonModule,
      TranslateModule,
      FieldErrorDisplayComponent,
      MatDatepickerModule,
      ReactiveFormsModule
    ],
  standalone: true
})

/* This class is responsible for Gathering user's health imformation (audiogram)  */
export class HealthCareComponent implements OnInit, OnChanges,AfterViewInit {
  public maxDate = new Date();
  public minDate = new Date(1900, 0, 1);
  public invalidFutureYear: boolean = false;
  public invalidPastYear: boolean = false;
  public iscommonerrormsg: boolean = false;
  @Input() public claimId: number;
  @Input() public referenceNumber: string;
  @Input() public locale: string;
  @Input() public healthCareProviderInfo: HealthCareProviderInfo;
  @Input() public personalInformation: PersonalInfo;
  @Input() set resultofSaveonExit(value: string) {
    this.saveData(value);
  }
  @Output() formStatus: EventEmitter<boolean> = new EventEmitter();
  @Output() showSuccess: EventEmitter<boolean> = new EventEmitter();
  @Output() next: EventEmitter<void> = new EventEmitter();
  @Output() previous: EventEmitter<void> = new EventEmitter();
  @Output() saveDataonExit1: EventEmitter<any> = new EventEmitter();
  @ViewChild('name') nameField: ElementRef;


  @ViewChild('audiogramClinicAddress')
  public audiogramClinicAddressElementRef: ElementRef;

  @ViewChild('entSpecialistAddress')
  public entSpecialistAddressElementRef: ElementRef;

  continueHealthCareForm = new UntypedFormGroup({
    hearingLossNoticedYear: new UntypedFormControl('', [Validators.required, futureDateValidation, pastDateValidation]),
    dateOfFirstAudiogram: new FormControl<moment.Moment | null>(null, Validators.required),
    audiogramClinicName: new UntypedFormControl(null, [Validators.required, Validators.pattern(`^[A-Za-z0-9\-\Çéâêîôûàèùëïü./'#@%&:;,\\n ]*$`)]),
    audiogramClinicAddress: new UntypedFormControl(null, [Validators.required]),
    audiogramClinicPhoneNumber: new UntypedFormControl(null, Validators.required),
    hasVisitedEntSpecialist: new UntypedFormControl(null, Validators.required),
    entAppointmentDate: new FormControl<moment.Moment | null>(null),
    entSpecialistName: new UntypedFormControl(null),
    entSpecialistPhoneNumber: new UntypedFormControl(null),
    entSpecialistAddress: new UntypedFormControl(null),
    hasRingingInEar: new UntypedFormControl(null, Validators.required),
    ringingEarDuration: new UntypedFormControl(null),
    hasSevereRingingInEar: new UntypedFormControl(null),
    hasConstantRingingInEar: new UntypedFormControl(null),
    hasHearingAid: new UntypedFormControl(null, Validators.required),
    hearingAidUsageDate: new FormControl<moment.Moment | null>(null),
  });

  constructor(
    private healthCareProviderInfoService: HealthCareProviderInfoService,
    private validationService: ValidationService,
    private timeout: TimeoutService,
    private translate: TranslateService,
    public googleplaces: DynamicScriptsService,
    private ngZone: NgZone,
    private dateAdapter: DateAdapter<moment.Moment>
  ) {

  }

  ngOnInit() {

    this.loadHealthCareInfo();
    this.checkNullForm();
    this.entValidation();
    this.ringValidation();
    this.aidValidation();
    this.dateAdapter.setLocale(this.locale);
  }

  ngAfterViewInit() {
    this.googleplaces.api.then(maps => {
      this.initAutocomplete(maps, this.audiogramClinicAddressElementRef?.nativeElement, 0);
    });
  }

  initAutocomplete(maps: Maps, element, indx) {
    const autocomplete = new maps.places.Autocomplete(element);
    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        this.addressChange(autocomplete.getPlace(), indx);
      });
    });
  }

  ngOnChanges(changes: SimpleChanges) {

    if (changes['locale']) {
      this.dateAdapter.setLocale(changes['locale'].currentValue);
    }
    
    if (this.nameField) {
      this.nameField?.nativeElement?.focus();
    }

    this.timeout.componentMethodCalled.subscribe((resp) => {
      if (resp === '1') {
        this.addOrUpdateHealthCareProviderInfo(false, false, false, false);
      }
    });
  }

  saveData(name) {
    if (sessionStorage.getItem('component') === '1') {
      if (name === 'exithealthcare') {

        this.addOrUpdateHealthCareProviderInfo(false, false, false, true);

        if (!this.continueHealthCareForm.valid) {
          this.saveDataonExit1.emit();
        }
      }
    }
  }


  aidValidation = () => {
    this.continueHealthCareForm.get('hasHearingAid').valueChanges.subscribe(checked => {
      if (checked === true) {
        this.continueHealthCareForm.get('hearingAidUsageDate').setValidators(Validators.required);
      } else {
        this.continueHealthCareForm.get('hearingAidUsageDate').setValidators(null);
        this.continueHealthCareForm.setErrors(null);
      }
      this.continueHealthCareForm.updateValueAndValidity();
    });
  }

  ringValidation = () => {
    this.continueHealthCareForm.get('hasRingingInEar').valueChanges.subscribe(checked => {
      if (checked === true) {
        this.continueHealthCareForm.get('ringingEarDuration').setValidators(Validators.required);
        this.continueHealthCareForm.get('hasSevereRingingInEar').setValidators(Validators.required);
        this.continueHealthCareForm.get('hasConstantRingingInEar').setValidators(Validators.required);
      } else {
        this.continueHealthCareForm.get('ringingEarDuration').setValidators(null);
        this.continueHealthCareForm.get('hasSevereRingingInEar').setValidators(null);
        this.continueHealthCareForm.get('hasConstantRingingInEar').setValidators(null);
        this.continueHealthCareForm.setErrors(null);

      }
      this.continueHealthCareForm.updateValueAndValidity();
    });
  }

  entValidation = () => {
    this.continueHealthCareForm.get('hasVisitedEntSpecialist').valueChanges.subscribe(checked => {
      if (checked === true) {

        this.continueHealthCareForm.get('entAppointmentDate').setValidators(Validators.required);
        this.continueHealthCareForm.get('entSpecialistName').setValidators([Validators.required, Validators.pattern('^[A-Za-zÇéâêîôûàèùëïü ]*$')]);
        this.continueHealthCareForm.get('entSpecialistPhoneNumber').setValidators(Validators.required);
        // this.continueHealthCareForm.get('entSpecialistAddress').setValidators([Validators.required, Validators.pattern(`^[A-Za-z0-9\-\Çéâêîôûàèùëïü./'#@%&:;,\\n ]*$`)]);
        this.continueHealthCareForm.get('entSpecialistAddress').setValidators([Validators.required]);
        setTimeout(() => {
          this.googleplaces.api.then(maps => {
            this.initAutocomplete(maps, this.entSpecialistAddressElementRef?.nativeElement, 1);
          });
        }, 500);

      } else {
        this.continueHealthCareForm.get('entAppointmentDate').setValidators(null);
        this.continueHealthCareForm.get('entSpecialistName').setValidators(null);
        this.continueHealthCareForm.get('entSpecialistPhoneNumber').setValidators(null);
        this.continueHealthCareForm.get('entSpecialistAddress').setValidators(null);
        this.continueHealthCareForm.setErrors(null);

      }
      this.continueHealthCareForm.updateValueAndValidity();
    });
  }

  checkNullForm = () => {
    if (
      this.continueHealthCareForm.get('hearingLossNoticedYear').value === null ||
      this.continueHealthCareForm.get('hearingLossNoticedYear').value === '' ||
      this.continueHealthCareForm.get('dateOfFirstAudiogram')?.value === null ||
      this.continueHealthCareForm.get('audiogramClinicName').value === null ||
      this.continueHealthCareForm.get('audiogramClinicName').value === '' ||
      this.continueHealthCareForm.get('audiogramClinicAddress').value === null ||
      this.continueHealthCareForm.get('audiogramClinicAddress').value === '' ||
      this.continueHealthCareForm.get('audiogramClinicPhoneNumber').value === null ||
      this.continueHealthCareForm.get('audiogramClinicPhoneNumber').value === '' ||
      this.continueHealthCareForm.get('hasVisitedEntSpecialist').value === null ||
      this.continueHealthCareForm.get('hasRingingInEar').value === null ||
      this.continueHealthCareForm.get('hasHearingAid').value === null
    ) {
      // console.log('one field is empty on basic questions');
      this.formStatus.emit(false);
      return;
    }

    if (this.continueHealthCareForm.get('hasVisitedEntSpecialist').value === true) {
      if (
        this.continueHealthCareForm.get('entAppointmentDate')?.value === null ||
        this.continueHealthCareForm.get('entSpecialistName').value === '' ||
        this.continueHealthCareForm.get('entSpecialistAddress').value === '' ||
        this.continueHealthCareForm.get('entSpecialistPhoneNumber').value === ''
      ) {
        // console.log('one field is empty on hasVisitedEntSpecialist = true');
        this.formStatus.emit(false);
        return;
      }
    }

    if (this.continueHealthCareForm.get('hasRingingInEar').value === true) {
      if (
        this.continueHealthCareForm.get('ringingEarDuration').value === null ||
        this.continueHealthCareForm.get('hasSevereRingingInEar').value === null ||
        this.continueHealthCareForm.get('hasConstantRingingInEar').value === null
      ) {
        // console.log('one field is empty on hasRingingInEar = true');
        this.formStatus.emit(false);
        return;
      }
    }

    if (this.continueHealthCareForm.get('hasHearingAid').value === true) {

      if (this.continueHealthCareForm.get('hearingAidUsageDate')?.value === null) {
        // console.log('hearingAidUsageDate field is empty');
        this.formStatus.emit(false);
        return;
      }
    }

    this.formStatus.emit(true);
    // console.log('all fields okay in continueHealthCareForm');

  }

  addressChange(address: any, value) {
    if (value === 0) {
      this.continueHealthCareForm.get('audiogramClinicAddress').setValue(this.parseAddress(address.formatted_address));
    } else if (value === 1) {
      this.continueHealthCareForm.get('entSpecialistAddress').setValue(this.parseAddress(address.formatted_address));
    }
  }

  parseAddress(address) {
    return address.replace(', ', '\n');
  }

  /*
  * @author Gowtham;
  * @date 08/15/2020;
  * @remarks Method responsible for adding or updating the health care provider info based on claimId.
  * It retrieves the entire claim object and storage it in the local storage.
  *   save(true,false,false)
  *   previous(false,true,false)
  *   next(false,false,true)"
  */
  addOrUpdateHealthCareProviderInfo = (isSave, alreadySaved, isNext = false, isExit?) => {
    // this.yearErrormessage = "";
    this.iscommonerrormsg = false;
    if (isSave && alreadySaved) {
      return;
    }

    if (this.continueHealthCareForm.valid) {

      const healthCareProviderInfo: HealthCareProviderInfo = {
        audiogramClinicAddress: this.continueHealthCareForm.get('audiogramClinicAddress').value,
        audiogramClinicName: this.continueHealthCareForm.get('audiogramClinicName').value,
        audiogramClinicPhoneNumber: this.continueHealthCareForm.get('audiogramClinicPhoneNumber').value,
        dateOfFirstAudiogram: this.continueHealthCareForm.get('dateOfFirstAudiogram')?.value?.format('YYYY-MM-DD'),
        entAppointmentDate: this.continueHealthCareForm.get('entAppointmentDate')?.value?.format('YYYY-MM-DD'),
        entSpecialistAddress: this.continueHealthCareForm.get('entSpecialistAddress').value,
        entSpecialistName: this.continueHealthCareForm.get('entSpecialistName').value,
        entSpecialistPhoneNumber: this.continueHealthCareForm.get('entSpecialistPhoneNumber').value,
        hasHearingAid: this.continueHealthCareForm.get('hasHearingAid').value,
        hasRingingInEar: this.continueHealthCareForm.get('hasRingingInEar').value,
        hasSevereRingingInEar: this.continueHealthCareForm.get('hasSevereRingingInEar').value,
        hasConstantRingingInEar: this.continueHealthCareForm.get('hasConstantRingingInEar').value,
        hasVisitedEntSpecialist: this.continueHealthCareForm.get('hasVisitedEntSpecialist').value,
        hearingAidUsageDate: this.continueHealthCareForm.get('hearingAidUsageDate')?.value?.format('YYYY-MM-DD'),
        hearingLossNoticedYear: this.continueHealthCareForm.get('hearingLossNoticedYear').value ? this.continueHealthCareForm.get('hearingLossNoticedYear').value : '',
        ringingEarDuration: this.continueHealthCareForm.get('ringingEarDuration').value,
      };

      const token = sessionStorage.getItem('access_token');
      this.healthCareProviderInfoService.addOrUpdateHealthCareProviderInfo(this.claimId, healthCareProviderInfo, token).subscribe(
        (res: Claim) => {
          sessionStorage.setItem('claim', JSON.stringify(res));
          this.showSuccess.emit(isSave);

          if (isExit) {
            sessionStorage.clear();

            const lang = sessionStorage.getItem('currentLang');
            const isEnglish = lang === 'en' ? true : false;
            const isFrench = lang === 'fr' ? true : false;

            let exitLink: any;

            if (isFrench) {
              exitLink = 'https://www.wsib.ca/fr/servicesenligne';
            } else {
              exitLink = 'https://wsib.ca/en/onlineservices';
            }
            setTimeout(() => {
              window.location.href = exitLink;
            }, 500);
            return;
          }

          if (!isSave) {
            if (isNext) {
              this.next.emit();
             } else {
               this.previous.emit();
             }
          }

        },
        error => {
          this.iscommonerrormsg = true;
          document.getElementById('commonerrormsgid')?.focus();

          // this.toastr.error(error?.error?.error, 'Error');
        }
      );
    } else {
      this.validationService.validateAllFormFields(this.continueHealthCareForm);
    }
  }

  loadHealthCareInfo = () => {
    if (this.healthCareProviderInfo) {
      this.continueHealthCareForm.get('audiogramClinicAddress').setValue(this.healthCareProviderInfo.audiogramClinicAddress);
      this.continueHealthCareForm.get('audiogramClinicName').setValue(this.healthCareProviderInfo.audiogramClinicName);
      this.continueHealthCareForm.get('audiogramClinicPhoneNumber').setValue(this.healthCareProviderInfo.audiogramClinicPhoneNumber);
      this.continueHealthCareForm.get('dateOfFirstAudiogram').setValue(loadDateToMoment(this.healthCareProviderInfo.dateOfFirstAudiogram));
      this.continueHealthCareForm.get('entAppointmentDate').setValue(loadDateToMoment(this.healthCareProviderInfo.entAppointmentDate));
      this.continueHealthCareForm.get('entSpecialistAddress').setValue(this.healthCareProviderInfo.entSpecialistAddress);
      this.continueHealthCareForm.get('entSpecialistName').setValue(this.healthCareProviderInfo.entSpecialistName);
      this.continueHealthCareForm.get('entSpecialistPhoneNumber').setValue(this.healthCareProviderInfo.entSpecialistPhoneNumber);
      this.continueHealthCareForm.get('hasHearingAid').setValue(this.healthCareProviderInfo.hasHearingAid);
      this.continueHealthCareForm.get('hasRingingInEar').setValue(this.healthCareProviderInfo.hasRingingInEar);
      this.continueHealthCareForm.get('hasSevereRingingInEar').setValue(this.healthCareProviderInfo.hasSevereRingingInEar);
      this.continueHealthCareForm.get('hasConstantRingingInEar').setValue(this.healthCareProviderInfo.hasConstantRingingInEar);
      this.continueHealthCareForm.get('hasVisitedEntSpecialist').setValue(this.healthCareProviderInfo.hasVisitedEntSpecialist);
      this.continueHealthCareForm.get('hearingAidUsageDate').setValue(loadDateToMoment(this.healthCareProviderInfo.hearingAidUsageDate));
      this.continueHealthCareForm.get('ringingEarDuration').setValue(this.healthCareProviderInfo.ringingEarDuration);
      this.continueHealthCareForm.get('hearingLossNoticedYear').setValue(this.healthCareProviderInfo.hearingLossNoticedYear);
      setTimeout(() => {
      if (this.healthCareProviderInfo.hasVisitedEntSpecialist) {
        this.googleplaces.api.then(maps => {
          this.initAutocomplete(maps, this.entSpecialistAddressElementRef?.nativeElement, 1);
        });
      }
    }, 200);
    }
  }


  hasHearingAidChange = () => {
    this.continueHealthCareForm.get('hearingAidUsageDate').setValue(null);
  }

  hasVisitedEntSpecialistChange = () => {

    this.continueHealthCareForm.get('entAppointmentDate').setValue(null);
    this.continueHealthCareForm.get('entSpecialistName').setValue(null);
    this.continueHealthCareForm.get('entSpecialistAddress').setValue(null);
    this.continueHealthCareForm.get('entSpecialistPhoneNumber').setValue(null);
  }

  hasRingingInEarChange = () => {
    this.continueHealthCareForm.get('ringingEarDuration').setValue(null);
    this.continueHealthCareForm.get('hasSevereRingingInEar').setValue(null);
    this.continueHealthCareForm.get('hasConstantRingingInEar').setValue(null);

  }

  private formatDate = (date?: Date | string) => {
    date = new Date(date);
    if (date) {
      return `${date.getFullYear()}-${this.addprfix(date.getMonth() + 1)}-${this.addprfix(date.getDate())}`;
    }
    return null;
  }

  private addprfix = (val: number) => {
    if (val < 10) {
      return `0${val}`;
    }
    return `${val}`;
  }

  isFieldValid(form: UntypedFormGroup, field: string, splchk = null) {
    if (splchk === null) {
      return !form.get(field).valid && form.get(field).touched;
    } else {
      if (splchk) {
        return !form.get(field).valid && form.get(field).touched && !form.get(field).value;
      } else {
        return !form.get(field).valid && form.get(field).touched && form.get(field).value;
      }
    }
  }

  isFieldTouched(form: UntypedFormGroup, field: string, splchk = null) {
    if (form.get(field).touched) {
      return this.isFieldValid(form, field, splchk);
    } else {
      return false;
    }
  }

  displayFieldCss(form: UntypedFormGroup, field: string) {
    return {
      'has-error': this.isFieldValid(form, field)
    };
  }

  validateYear(event: any) {
    const dateOfBirth = sessionStorage.getItem('dateOfBirth');
    if (dateOfBirth) {
      const getYear = new Date(dateOfBirth).getFullYear();
      const getCurrentYear = new Date().getFullYear();
      // const getpastYear = getCurrentDate.getFullYear();

      if (+getCurrentYear < Number(event.target.value)) {

        this.continueHealthCareForm.get('hearingLossNoticedYear').setErrors({ incorrect: true });

        this.invalidFutureYear = true;
        this.invalidPastYear = false;
      }
      else if (+getYear > Number(event.target.value)) {
        this.invalidFutureYear = false;
        this.invalidPastYear = true;
      }
      else {
        this.continueHealthCareForm.get('hearingLossNoticedYear').setValue(event.target.value.replace(/[^0-9]*/g, ''));

        this.invalidFutureYear = false;
        this.invalidPastYear = false;


      }

    }
    if (event.keyCode > 47 && event.keyCode < 58) {
      return;
    }
  }

  replaceSpaces(formControl: string) {
    let value = this.continueHealthCareForm.get(formControl).value;
    value = value.replace(/\s\s+/g, ' ');
    if (value) {
      this.continueHealthCareForm.get(formControl).setValue(value);
    }
  }

  trimpaces(formControl: string) {
    const value = this.continueHealthCareForm.get(formControl).value;
    if (value) {
      this.continueHealthCareForm.get(formControl).setValue(value.trim());
    }
  }

  datePickerValidationCheck(form: UntypedFormGroup, field: string, validadtionType: string): boolean {
    return datePickerValidationCheckImpl(form, field, validadtionType);
  }
  
  checkPhone(event, field) {
    if (event.keyCode > 47 && event.keyCode < 58) {
      return;
    } else if (field === 'adClinic') {
      this.continueHealthCareForm.get('audiogramClinicPhoneNumber').setValue(event.target.value.replace(/[^0-9-+() ]*/g, ''));
    } else if (field === 'entSpecialist') {
      this.continueHealthCareForm.get('entSpecialistPhoneNumber').setValue(event.target.value.replace(/[^0-9-+() ]*/g, ''));
    }
  }
}

function futureDateValidation(control: UntypedFormControl) {
  const num = control.value;
  const currentDate = new Date();
  if (num) {
    if (num > currentDate.getFullYear()) {
      return { invalid: true };
    } else {
      return null;
    }
  }
  return null;
}

function pastDateValidation(control: UntypedFormControl) {
  const num = control.value;
  const dateOfBirth = sessionStorage.getItem('dateOfBirth');
  if (dateOfBirth) {
    const getYear = new Date(dateOfBirth).getFullYear();
    if (num) {
      if (num < getYear) {
        return { invalid: true };
      } else {
        return null;
      }
    }
  }
  return null;
}

